import { render, staticRenderFns } from "./goodsCategory.vue?vue&type=template&id=18d36346"
import script from "./goodsCategory.vue?vue&type=script&lang=ts"
export * from "./goodsCategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports